var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_584_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4418 3.12061H14.1744V11.1106H37.5569V7.23402C37.5569 4.96567 35.7108 3.12061 33.4418 3.12061Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 12.3403H0V4.92636C0 2.20972 2.21068 0 4.92828 0H12.1336C12.8497 0 13.5396 0.150925 14.1664 0.434509C15.0418 0.828964 15.7939 1.47913 16.3213 2.3286L22.5352 12.3403Z",
    fill: "#5030E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.0001V37.8815C42 40.1527 40.1511 42 37.8789 42H4.12111C1.84891 42 0 40.1527 0 37.8815V9.88062H37.8789C40.1511 9.88062 42 11.7286 42 14.0001Z",
    fill: "#5030E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.0001V37.8815C42 40.1527 40.1511 42 37.8789 42H21V9.88062H37.8789C40.1511 9.88062 42 11.7286 42 14.0001Z",
    fill: "#5030E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0479 25.9398C32.0479 32.0322 27.0918 36.9887 21 36.9887C14.9082 36.9887 9.95203 32.0322 9.95203 25.9398C9.95203 19.8483 14.9082 14.8918 21 14.8918C27.0918 14.8918 32.0479 19.8483 32.0479 25.9398Z",
    fill: "#E7ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0479 25.9398C32.0479 32.0322 27.0918 36.9887 21 36.9887V14.8918C27.0918 14.8918 32.0479 19.8483 32.0479 25.9398Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.561 26.0753C24.3306 26.2704 24.0483 26.3656 23.7685 26.3656C23.4183 26.3656 23.0703 26.2173 22.8268 25.9282L22.2304 25.2213V29.8494C22.2304 30.5287 21.6793 31.0799 21 31.0799C20.3207 31.0799 19.7695 30.5287 19.7695 29.8494V25.2213L19.1732 25.9282C18.7342 26.4476 17.9584 26.514 17.439 26.0753C16.9199 25.6373 16.8532 24.8612 17.2913 24.3418L19.7269 21.4543C20.0444 21.0788 20.5078 20.8628 21 20.8628C21.4922 20.8628 21.9555 21.0788 22.2731 21.4543L24.7087 24.3418C25.1467 24.8612 25.0801 25.6373 24.561 26.0753Z",
    fill: "#B3A6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.561 26.0753C24.3306 26.2704 24.0483 26.3656 23.7686 26.3656C23.4183 26.3656 23.0703 26.2173 22.8268 25.9282L22.2305 25.2213V29.8494C22.2305 30.5287 21.6793 31.0799 21 31.0799V20.8628C21.4922 20.8628 21.9555 21.0788 22.2731 21.4543L24.7087 24.3418C25.1467 24.8612 25.0801 25.6373 24.561 26.0753Z",
    fill: "#927FEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_584_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/upload-img.7fb304f21d179d15472770c7df7bde73.svg";
export { ForwardRef as ReactComponent };